import { ModuleConstants } from '../../common/constant/modules';
import { ModuleRoutesComponentInterface } from '../../common/routes/types';
import { generateImage } from '../../common/utils/generateImage';
import { ComponentsMap } from './components';
import { ScreenNames } from './screens';
import { RouteConstantsInterface } from './types';

export enum EmailRedirectedRoutes {
  SIGNUP = 'signup',
  VERIFY = 'verify-user',
  RESET_PASSWORD = 'reset-password',
}

export enum RouteConstantEnums {
  HOME,
}

export const RouteConstants: RouteConstantsInterface = {
  HOME: '/',
};

const getBaseModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.HOME,
      title: ScreenNames.HOME,
      icon: generateImage({
        noScale: true,
        name: 'home-05',
        alt: 'User Management Home',
        className: 'w-4 h-4',
      }),
      sidebarVisibility: false,
      component: ComponentsMap.HOME,
    },
  ];
};

export default getBaseModuleRoutes;
